export default __webpack_public_path__ + "static/media/a1-3-3.75d5c6ca.jpg";